<template>
    <div v-if="loading" class="loading">Loading...</div>
    <div class='absolute h-full xl:top-40 lg:top-40 md:top-20 sm:top-20 right-10 -left-10 p-2' :class="disable ? 'hidden' : '' ">
        <div class="flex w-full fixed">
            <div class="w-2/5">
                <img class="w-full scale-125" src="../assets/avatar/avatar1.png" alt="old man">
            </div>
            <div class="flex flex-col w-3/5">
                <div class="flex flex-col bg-transparent shadow-rose-300 h-fit border-6 border-indigo-300 ring-4 p-2 rounded-lg">
                    <div class="w-full">
                        <p class="xl:text-5xl lg:text-4xl md:text-2xl sm:text-2xl text-black font-bold leading-relaxed text-center underline decoration-pink-500" style="text-shadow: 4px 4px 20px rgb(249 250 251);">วิธีการเล่น</p> 
                        <p class="mt-2 xl:text-5xl lg:text-4xl md:text-2xl sm:text-2xl text-black font-bold leading-relaxed text-center whitespace-pre-wrap align-middle" style="text-shadow: 4px 4px 20px rgb(249 250 251);">{{ how_to }}</p> 
                    </div>
                    <div class="flex w-full items-end justify-end" @click="playSoundHowTo()">                    
                        <Sound :checkpoint='checkpoint' :autoplay='true'/>
                    </div>
                </div>            
                <div class="flex items-center justify-end mt-5">
                    <button @click="[setShowContent(), setDisable(), playSoundOther($store.state.level)]" class="cursor-pointer w-max p-4 px-9 bg-sky-500 text-white font-bold text-[30px] rounded-lg shadow-lg hover:ring-4 hover:ring-bg-sky-100">เริ่มเล่นเกม</button>
                </div>
            </div>
        </div>            
    </div>         
    <router-view></router-view>    
</template>

<script>
import Sound from "./Sound.vue";

const howToEachCheckpoint = {
    1: 'ให้ผู้เล่นนำเข็มนาฬิกาไป วางให้ถูกต้องตามเวลาที่กำหนด',
    2: 'จงเลือกสิ่งของที่จำเป็นในการใช้อาบน้ำ',
    3: 'ให้ผู้เล่นแยกขยะทิ้งตามสีและประเภทของถังขยะ',
    4: 'ผู้เล่นจะต้องระบุสิ่งที่ตนเองเห็นให้ตรงกับคำที่ปรากฏ',
    5: 'ผู้เล่นจะต้องคำนวณราคาสินค้าที่ตนเองซื้อให้ถูกต้อง',
    6: 'ผู้เล่นจะต้องจับคู่ภาพเหมือนให้ถูกต้อง'
}

const checkHowToByCheckpoint = (checkpoint) => {
    return howToEachCheckpoint[checkpoint];
}

export default {
    name: "HowTo",
    components: {
        Sound
    },
    props: {
        text: String,
        message: String,
        setShowContent: Function,
        checkpoint: String,        
    },  
    data(){
        return {
            disable: false,    
            level: this.$route.query.level,
            how_to: checkHowToByCheckpoint(this.checkpoint),
            path: '',
        };        
    },     
    methods: {
        setDisable() {
            this.disable = true           
        },
        playSoundOther(level) {            
            let checkpoint_1_easy = '../assets/sound/checkpoint_1_easy.m4a';
            let checkpoint_1_medium = '../assets/sound/checkpoint_1_medium.m4a';
            let checkpoint_1_hard = '../assets/sound/checkpoint_1_hard.m4a';
            let checkpoint_3 = '../assets/sound/checkpoint_3_description_bin.m4a';
            
            const playSoundSecond = () => {
                if(this.checkpoint === 1){                  
                    if(level === 'easy') { 
                      this.path = checkpoint_1_easy;
                    }else if(level === 'medium') {
                      this.path = checkpoint_1_medium;
                    }else {
                      this.path = checkpoint_1_hard;
                    }
                }else if(this.checkpoint === 3){
                    this.path = checkpoint_3;
                }

                var audio = new Audio(this.path);          
                audio.play();                
            }

            const playSoundFirst = () => {                
                var audio = new Audio(`../assets/sound/checkpoint_${this.checkpoint}.m4a`);                
                audio.play()                
            }

            
            playSoundFirst(); 
            setTimeout(()=> {
                playSoundSecond();
            }, 2300);                                                  
        }
    }
};
</script>